import { render, staticRenderFns } from "./TableScrollPage.vue?vue&type=template&id=6083b86c&"
import script from "./TableScrollPage.vue?vue&type=script&lang=js&"
export * from "./TableScrollPage.vue?vue&type=script&lang=js&"
import style0 from "./TableScrollPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports